import React from "react";
import "./MobileFilterModal.css";

export default function MobileFilterModal({
  open,
  onClose,

  rooms,
  doctors,

  filterRoom,
  setFilterRoom,

  filterDoctor,
  setFilterDoctor,

  filterDate,
  setFilterDate,

  keyword,
  setKeyword,

  onReset,
}) {
  if (!open) return null;

  return (
    <div className="mfm-backdrop" onClick={onClose}>
      <div
        className="mfm-sheet"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mfm-header">
          <span>Bộ lọc lịch khám</span>
          <button onClick={onClose}>✕</button>
        </div>

        <div className="mfm-body">
          <label>Phòng khám</label>
          <select
            value={filterRoom}
            onChange={(e) => setFilterRoom(e.target.value)}
          >
            <option value="">Tất cả</option>
            {rooms.map((r) => (
              <option key={r.id} value={r.id}>
                {r.tenPhong}
              </option>
            ))}
          </select>

          <label>Bác sĩ</label>
          <select
            value={filterDoctor}
            onChange={(e) => setFilterDoctor(e.target.value)}
          >
            <option value="">Tất cả</option>
            {doctors.map((d, i) => (
              <option key={i} value={d}>
                {d}
              </option>
            ))}
          </select>

          <label>Ngày</label>
          <input
            type="date"
            value={filterDate}
            onChange={(e) => setFilterDate(e.target.value)}
          />

          <label>Tìm kiếm</label>
          <input
            type="text"
            placeholder="Tên bác sĩ / phòng..."
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </div>

        <div className="mfm-footer">
          <button className="reset" onClick={onReset}>
            Reset
          </button>
          <button className="apply" onClick={onClose}>
            Áp dụng
          </button>
        </div>
      </div>
    </div>
  );
}
